import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Loader2, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function Newsletter({ variant = "footer" }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [website, setWebsite] = useState(""); // honeypot
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Enter your email to subscribe.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/subscribers`, { email, name, website });
      if (data.status === "already_subscribed") {
        toast.info(data.message);
      } else {
        toast.success(data.message);
      }
      setDone(true);
      setEmail("");
      setName("");
    } catch (err) {
      toast.error(err.response?.data?.detail?.toString?.() || "Couldn't subscribe. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const isBlock = variant === "block";
  const inputCls =
    "w-full bg-white/5 border-0 border-b border-white/20 rounded-none px-4 py-3.5 text-white placeholder-white/30 focus:outline-none focus:border-gold transition-colors duration-300";

  if (done) {
    return (
      <div className="flex items-center gap-3 text-white/80" data-testid="newsletter-success">
        <CheckCircle2 className="w-5 h-5 text-gold" />
        <span>You&apos;re subscribed — watch your inbox for our weekly deals.</span>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className={isBlock ? "max-w-xl" : "w-full"} data-testid="newsletter-form">
      {/* Honeypot — hidden from users, catches bots */}
      <input
        type="text"
        name="website"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        value={website}
        onChange={(e) => setWebsite(e.target.value)}
        className="absolute left-[-9999px] w-px h-px overflow-hidden opacity-0"
        data-testid="hp-newsletter-website"
      />
      <div className={isBlock ? "grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4" : "space-y-3"}>
        <input
          className={inputCls}
          placeholder="Your name (optional)"
          value={name}
          onChange={(e) => setName(e.target.value)}
          data-testid="newsletter-name"
        />
        <input
          type="email"
          className={inputCls}
          placeholder="Email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="newsletter-email"
        />
      </div>
      <button
        type="submit"
        disabled={loading}
        data-testid="newsletter-submit"
        className={`inline-flex items-center justify-center gap-2 bg-gold text-white text-sm uppercase tracking-[0.14em] font-semibold px-6 py-3.5 hover:bg-[#b00000] transition-colors duration-300 disabled:opacity-60 ${
          isBlock ? "" : "w-full mt-3"
        }`}
      >
        {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Subscribing…</> : <>Subscribe <ArrowRight className="w-4 h-4" /></>}
      </button>
    </form>
  );
}
